import { createStore } from 'vuex'
import movementInstructionStore from './movementInstructionStore';
import securityStore from './securityStore'
import masterDataStore from './masterDataStore';
import notificationStore from './notificationStore';
import cacheDataStore from './cacheDataStore';
import operativePlanStore from './operativePlanStore';

const generic = {
  namespaced: true,
    state: () => ({
      loading: false
    }),
    mutations: {
      setLoading(state, loading){
        state.loading = loading;
      }
    },
    actions: {
      setLoading({commit}, payload){
        commit("setLoading", payload)
    }
  }
}

export default createStore({
    modules: {
      generic: generic,
      security: securityStore,
      movementInstruction: movementInstructionStore,
      masterData: masterDataStore,
      notifications: notificationStore,
      cacheDataStore: cacheDataStore,
      operativePlan: operativePlanStore
    }
  })